import { BillingDataResponseDTO } from '@core/api/dtos/response/accounts/billingData'
import { BillingData } from '@core/api/entities/account/billingData'

export class BillingDataMapper {
	static toEntity(dto: BillingDataResponseDTO): BillingData {
		return BillingData.create({
			id: dto.id,
			officialCompanyName: dto.official_company_name,
			tax: dto.tax,
			notificationEmails: dto.notification_emails,
			invoiceAutomatically: dto.invoice_automatically,
			sendInvoiceAutomatically: dto.send_invoice_automatically,
			taxId: dto.tax_id,
			billingSystemId: dto.billing_system_id,
			invoiceIntegrationId: dto.invoice_integration_id,
			chargeAutomatically: dto.charge_automatically,
			country: dto.country,
			state: dto.state,
			city: dto.city,
			street: dto.street,
			zip: dto.zip,
		})
	}

	static toEntities(dtos: BillingDataResponseDTO[]): BillingData[] {
		return dtos.map(this.toEntity)
	}
}
